import React from "react";

const TAGS = ["", "SCORM", "QUIZ", "VIDEO", "PDF", "EVALUATION", "EVENEMENT", "GENERAL"];
const SORTS = [
    { value: "RECENT", label: "Plus récentes" },
    { value: "MOST_REPLIES", label: "Plus de réponses" },
    { value: "MOST_LIKED", label: "Plus likées" },
    { value: "UNRESOLVED_FIRST", label: "Non résolues d'abord" },
];

export default function ContentQuestionFilters({ filters, onChange }) {
    const setFilter = (patch) => onChange?.({ ...filters, ...patch });

    return (
        <div className="cq-filters">
            <div className="cq-segmented" aria-label="Filtres questions">
                <button type="button" className={filters.status === "ALL" && !filters.mine ? "is-active" : ""} onClick={() => setFilter({ status: "ALL", mine: false })}>
                    Toutes
                </button>
                <button type="button" className={filters.mine ? "is-active" : ""} onClick={() => setFilter({ mine: !filters.mine })}>
                    Mes questions
                </button>
                <button type="button" className={filters.status === "UNRESOLVED" ? "is-active" : ""} onClick={() => setFilter({ status: "UNRESOLVED" })}>
                    Non résolues
                </button>
                <button type="button" className={filters.status === "RESOLVED" ? "is-active" : ""} onClick={() => setFilter({ status: "RESOLVED" })}>
                    Résolues
                </button>
            </div>

            <select className="cq-select" value={filters.tag || ""} onChange={(event) => setFilter({ tag: event.target.value })}>
                {TAGS.map((tag) => (
                    <option key={tag || "ALL"} value={tag}>
                        {tag || "Tous les tags"}
                    </option>
                ))}
            </select>

            <select className="cq-select" value={filters.sort || "RECENT"} onChange={(event) => setFilter({ sort: event.target.value })}>
                {SORTS.map((sort) => (
                    <option key={sort.value} value={sort.value}>
                        {sort.label}
                    </option>
                ))}
            </select>
        </div>
    );
}
